import request from '@/utils/request'

export function getFocusOn(data) {
    return request({
        url: 'admin/app/user/getWebFocusOn',
        method: 'POST',
        data: data
    })
}

export function saveFocusOn(data) {
    return request({
        url: 'admin/app/user/saveWebFocusOn',
        method: 'POST',
        data: data
    })
}

export function getPortalFocusOn(data) {
    return request({
        url: 'admin/app/user/getWebPortalFocusOn',
        method: 'POST',
        data: data
    })
}

export function getPortalSubscribe(data) {
    return request({
        url: 'admin/app/user/getWebPortalSubscribe',
        method: 'POST',
        data: data
    })
}

// 获取辅助决策用户权限信息
export function getAuxiliaryUser(userName) {
    return request({
        baseURL: process.env.VUE_APP_FZJCPERMISSIONS_URL,
        url: '/api/v1/user/external/auth',
        method: 'get',
        params:{
            'username':userName
        },
        // headers:{
        //     Authorization:Authorization
        // },
    })
}

// 列表
export function listPage(data) {
    return request({
      url: 'admin/data/subscription/list',
      method: 'post',
      data
    })
  }

